import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './RegisterUser.css';  // Import the CSS file

function RegisterUser() {
  const [email, setEmail] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [addressLine1, setAddressLine1] = useState('');
  const [addressLine2, setAddressLine2] = useState('');
  const [postcode, setPostcode] = useState('');
  const [city, setCity] = useState('');
  const [country, setCountry] = useState('');
  const [vat, setVAT] = useState('');  
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const countries = [
    { code: 'AU', name: 'Australia' },
    { code: 'AT', name: 'Austria' },
    { code: 'BE', name: 'Belgium' },
    { code: 'BR', name: 'Brazil' },
    { code: 'BG', name: 'Bulgaria' },
    { code: 'CA', name: 'Canada' },
    { code: 'HR', name: 'Croatia' },
    { code: 'CY', name: 'Cyprus' },
    { code: 'CZ', name: 'Czech Republic' },
    { code: 'DK', name: 'Denmark' },
    { code: 'EE', name: 'Estonia' },
    { code: 'FI', name: 'Finland' },
    { code: 'FR', name: 'France' },
    { code: 'DE', name: 'Germany' },
    { code: 'GI', name: 'Gibraltar' },
    { code: 'GR', name: 'Greece' },
    { code: 'HK', name: 'Hong Kong' },
    { code: 'HU', name: 'Hungary' },
    { code: 'IN', name: 'India' },
    { code: 'ID', name: 'Indonesia' },
    { code: 'IE', name: 'Ireland' },
    { code: 'IT', name: 'Italy' },
    { code: 'JP', name: 'Japan' },
    { code: 'LV', name: 'Latvia' },
    { code: 'LI', name: 'Liechtenstein' },
    { code: 'LT', name: 'Lithuania' },
    { code: 'LU', name: 'Luxembourg' },
    { code: 'MY', name: 'Malaysia' },
    { code: 'MT', name: 'Malta' },
    { code: 'MX', name: 'Mexico' },
    { code: 'NL', name: 'Netherlands' },
    { code: 'NZ', name: 'New Zealand' },
    { code: 'NO', name: 'Norway' },
    { code: 'PL', name: 'Poland' },
    { code: 'PT', name: 'Portugal' },
    { code: 'RO', name: 'Romania' },
    { code: 'SG', name: 'Singapore' },
    { code: 'SK', name: 'Slovakia' },
    { code: 'SI', name: 'Slovenia' },
    { code: 'ES', name: 'Spain' },
    { code: 'SE', name: 'Sweden' },
    { code: 'CH', name: 'Switzerland' },
    { code: 'TH', name: 'Thailand' },
    { code: 'AE', name: 'United Arab Emirates' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'US', name: 'United States' },
  ];

  // Handle the register request
  const handleRegisterRequest = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_FQDN}/api/add-new-user-group`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          companyName,
          addressLine1,
          addressLine2,
          postcode,
          city,
          country,
          vat,
        }),
      });

      if (response.ok) {
        setMessage('Successfully registered. Please check your inbox to create a new password. If you cannot find it, please check the SPAM folder');
        setLoading(false);
      } else {
        const data = await response.json();
        setError(data.error || 'Failed to register. Please try again.');
        setLoading(false);
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <div className="register-box">
        <h2>Register</h2>
        <p>To join an existing company, you need to be invited by a current member of that company. <br></br> <br></br>
        After you complete your registration, if you don’t see the invitation email in your inbox, 
        be sure to check your spam or junk folder. If you find the email there, mark it as 'Not Spam' 
        to ensure future emails are delivered to your inbox.</p>
        {error && <p className="register-error-message">{error}</p>}
        {message && <p className="register-success-message">{message}</p>}
        <form onSubmit={handleRegisterRequest}>
          <div className="register-form-group">
           <div className="register-column">
            <label htmlFor="email" className="register-label"></label>
            <input
              type="email"
              className="register-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              autoComplete="email"
              required
              disabled={loading}
            />
            <input
              type="text"
              className="register-input"
              value={vat}
              onChange={(e) => setVAT(e.target.value)}
              placeholder="Company VAT (optional)"
              disabled={loading}
            />
            
            
          </div>
          <div className="register-column">
            <label htmlFor="group" className="register-label"></label>
            <input
              type="text"
              id="group"
              className="register-input"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              placeholder="Company name"
              required
              disabled={loading}
            />
            <input
              type="text"
              className="register-input"
              value={addressLine1}
              onChange={(e) => setAddressLine1(e.target.value)}
              placeholder="1st line of the company address"
              required
              disabled={loading}
            />
            <input
              type="text"
              className="register-input"
              value={addressLine2}
              onChange={(e) => setAddressLine2(e.target.value)}
              placeholder="2nd line of the company address (optional)"
              disabled={loading}
            />
            <input
              type="text"
              className="register-input"
              value={postcode}
              onChange={(e) => setPostcode(e.target.value)}
              placeholder="Company postcode/zipcode"
              required
              disabled={loading}
            />
            
            <input
              type="text"
              className="register-input"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              placeholder="Company city"
              required
              disabled={loading}
            />
            <select
              id="country"
              className="register-input"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              required
              disabled={loading}
            >
              <option value="" disabled>Company country</option>
              {countries.map((country) => (
                <option key={country.code} value={country.code}>
                  {country.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <button type="submit" className="register-button" disabled={loading}>
          {loading ? 'Registering...' : 'Register'}
        </button>
      </form>

        {loading && <div className="register-spinner"></div>}

        <div className="register-back-to-login">
          <Link to="/login">Go back to login</Link>
        </div>
      </div>
    </div>
  );
}

export default RegisterUser;
